import Header from "component/Header/Header";
import Container from "@mui/material/Container";
import ValeInfoContent from "component/ValeInfoContent/ValeInfoContent";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "project",
    page: "vale",
  },
  dataLayerName: "Vales",
};

const Vale = (props) => {
  TagManager.dataLayer(tagManagerArgs);

  const qr = props.qr;
  const valeHeader = (
    <Container
      maxWidth="md"
      style={{
        marginTop: "7%",
      }}
    >
      <h1>Vale Seleccionado</h1>
      <p style={{ fontSize: "28px" }}>
        Si los datos son correctos presioná Confirmar y descargá el vale.
      </p>
    </Container>
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Header />
      <div>{valeHeader}</div>
      <div>
        <ValeInfoContent qr={qr} />
      </div>
      <br />
    </div>
  );
};

export default Vale;
